import { Box, Stack, Alert } from '@mui/material';
import { FieldSwitch, FieldText, FieldTextRequired } from '../../../form';
import { SlideFormProps } from './types';
import SlidePreview from './SlidePreview';
import { InfoOutlined } from '@mui/icons-material';

export default function TextSlideForm({
  slide,
  onUpdateField,
  hasQuestionInOtherSlide,
}: SlideFormProps) {
  return (
    <Stack direction="row" gap={3}>
      <Box sx={{ flex: 1 }}>
        <Stack gap={2}>
          <FieldTextRequired
            field={{
              name: 'title',
              label: 'Title',
              value: slide.templateData.title,
              handleValueChange: (value) => onUpdateField('title', value),
            }}
          />
          <FieldTextRequired
            field={{
              name: 'markdown',
              label: 'Description',
              value: slide.templateData.markdown,
              handleValueChange: (value) => onUpdateField('markdown', value),
            }}
            multiline
            rows={6}
            helperText="max. 600 characters"
            slotProps={{
              htmlInput: {
                maxLength: 600,
              },
            }}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              alignItems: 'flex-start',
            }}
          >
            <FieldSwitch
              field={{
                name: 'add_question',
                label: 'Add a question to this slide?',
                value: slide.templateData.add_question,
                handleValueChange: (value) =>
                  !hasQuestionInOtherSlide &&
                  onUpdateField('add_question', value),
              }}
              disabled={hasQuestionInOtherSlide}
            />
            {hasQuestionInOtherSlide && (
              <Alert
                severity="info"
                icon={<InfoOutlined />}
                sx={{
                  backgroundColor: 'transparent',
                  padding: 0,
                  '& .MuiAlert-icon': {
                    color: 'info.main',
                    padding: 0,
                    marginRight: '8px',
                  },
                  '& .MuiAlert-message': {
                    fontSize: '14px',
                    color: 'info.main',
                    padding: 0,
                  },
                }}
              >
                Only one question per story - You've already added a question on
                another slide.
              </Alert>
            )}
          </Box>
          {slide.templateData.add_question && !hasQuestionInOtherSlide && (
            <FieldText
              field={{
                name: 'question',
                label: 'Question',
                value: slide.templateData.question,
                handleValueChange: (value) => onUpdateField('question', value),
              }}
              helperText="max. 80 characters"
            />
          )}
        </Stack>
      </Box>

      <SlidePreview
        title={slide.templateData.title}
        description={slide.templateData.markdown}
        type="text"
        question={
          slide.templateData.add_question ? slide.templateData.question : null
        }
      />
    </Stack>
  );
}
